import React from 'react';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import Form from '../Form';
import ButtonPrimary from '../ButtonPrimary';
import { currencyFormat } from '../../constants';
import useApplication from '../../resources/applications/read';
import useForm from './useForm';
import ScrollableIframe from '../ScrollableIframe';
import RevolverOfferDetails from '../RevolverOfferDetails';
import Disclaimers from '../Disclaimers';

const RevolverViewOffer = () => {
  useRUMView('revolver-view-offer');
  const { data: application } = useApplication();

  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Screen
      header="Congratulations!"
      subheader={
        `You have prequalified for DigniFi's ExpressWay Credit Card with a line
         of credit up to ${currencyFormat.format(application.attributes.total_credit)}.`
      }
    >
      <RevolverOfferDetails />
      <Form form={form} onSubmit={handleSubmit}>
        <ScrollableIframe
          name="hasViewedIframe"
          src="/cdn/WebBank_DigniFi_Application_Disclosure.html"
          iframeTitle="WebBank DigniFi Application Disclosure"
        />
        <Disclaimers textAlign="left">
          By clicking “Submit Application,“ you&apos;re acknowledging that you have read
          and agree to the Solicitation Disclosure shown above.
        </Disclaimers>
        <ButtonPrimary isLoading={isSubmitting}>
          Submit Application
        </ButtonPrimary>
      </Form>
      <Disclaimers textAlign="left">
        Pricing may vary based on your ExpressWay transaction amount, between $350-$7,500,
        in combination with the monthly term of your Promotional Credit Plan. Your final
        APR will be illustrated on your final purchase receipt, emailed to you at the time
        of the transaction, and located by logging into your account.
      </Disclaimers>
      <Disclaimers textAlign="left">
        <>
          <sup>*</sup>
          All DigniFi ExpressWay credit cards are issued by WebBank. An annual fee of up to
          $79 may apply. Six-month deferred interest promotional offer is available on all
          approved purchases of $350 or more using the DigniFi ExpressWay credit card. No
          interest will be charged on the promotional purchase if you pay the promotional
          purchase amount in full within 6 months. If you do not, interest will be charged
          on the promotional purchase from the purchase date. A minimum monthly payment is
          required. The required minimum monthly payments may not pay off the promotional
          purchase by the end of the promotional period. Account must be open and current to
          be eligible for this offer. Regular account terms apply to non-promotional purchases
          and, after promotion ends, to your promotional purchases. Please see any special
          promotion advertising or other disclosures provided to you for the full terms of
          any special promotion offered. All applications for credit are based on an
          evaluation of credit history. The annual percentage rate (APR) ranges from
          27.99%-36%. If you are charged interest, the charge will be no less than $2.00.
        </>
      </Disclaimers>
    </Screen>
  );
};

export default RevolverViewOffer;
